// CLARTEXT · /abo · B2-E2 — Bausteine für die USP-Stories in Schuss 2
// (Kopf mit Entitlement-Badges → Nutzenzeilen → Schritte → Beweis → „Mehr").
// Reine Präsentation; jede Formulierung kommt aus AboSeite.jsx (SSoT D2 +
// Betreiberentscheidungen B2-E2). Entitlement-Badges sind immer sichtbar.
import { Check } from "lucide-react";

const BADGES = {
  grund: { cls: "abo-badge-grund", label: "Grundabo" },
  opt: { cls: "abo-badge-opt", label: "Optional · Add-on" },
  test: { cls: "abo-badge-test", label: "Im 14-Tage-Test enthalten" },
};

export function Badge({ kind, testId }) {
  const b = BADGES[kind];
  if (!b) return null;
  return (
    <span className={`abo-badge ${b.cls}`} data-testid={testId}>
      {b.label}
    </span>
  );
}

export function StoryHead({ eyebrow, badges = [], title, sub, testId }) {
  return (
    <div className="abo-story-head" data-testid={testId}>
      <div className="abo-story-meta">
        {eyebrow ? <span className="abo-overline">{eyebrow}</span> : null}
        {badges.length ? (
          <span className="abo-badges">
            {badges.map((k) => (
              <Badge key={k} kind={k} testId={`${testId}-badge-${k}`} />
            ))}
          </span>
        ) : null}
      </div>
      <h2 className="abo-h2" data-testid={`${testId}-h2`}>
        {title}
      </h2>
      {sub ? <p className="abo-lead">{sub}</p> : null}
    </div>
  );
}

export function StoryLines({ items, testId }) {
  return (
    <ul className="abo-lines" data-testid={testId}>
      {items.map((t) => (
        <li key={t}>
          <Check size={17} aria-hidden="true" />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  );
}

export function StorySteps({ steps, testId }) {
  return (
    <ol className="abo-steps" data-testid={testId}>
      {steps.map((s, i) => (
        <li className="abo-step" key={s.title} data-testid={`${testId}-${i + 1}`}>
          <span className="abo-step-num" aria-hidden="true">
            {i + 1}
          </span>
          <h4>{s.title}</h4>
          <p>{s.text}</p>
          <span className="abo-step-who">{s.who}</span>
        </li>
      ))}
    </ol>
  );
}

export function StoryProof({ caption, children, testId }) {
  return (
    <figure className="abo-proof" data-testid={testId}>
      {children}
      {caption ? (
        <figcaption className="abo-proof-caption">{caption}</figcaption>
      ) : null}
    </figure>
  );
}

export function StoryMore({ summary, children, testId }) {
  return (
    <details className="abo-details" data-testid={testId}>
      <summary data-testid={`${testId}-toggle`}>{summary}</summary>
      <div className="abo-details-body">{children}</div>
    </details>
  );
}
